import {DependencyDef} from "../parser/definition/types/DependencyDef";
import {compileDependencies} from "./compileDependencies";
import {compileArray} from "./utils/compileArray";
import {compileDictionary} from "./utils/compileDectionary";

export function compilePackageDescriptor(
  moduleName: string,
  dependencyDefs: Array<DependencyDef>,
  path: string
): string {
  const dependencies = {
    "@cranq/runtime": JSON.stringify("~0.2.0"),
    ...compileDependencies(dependencyDefs)
  };
  return `{
  "main": "${path}",
  "files": ${compileArray([JSON.stringify(path)])},
  "dependencies": ${compileDictionary(dependencies)}
}`;
}
